import { render, staticRenderFns } from "./PhoneOutline.vue?vue&type=template&id=23a15fc6"
import script from "./PhoneOutline.vue?vue&type=script&lang=js"
export * from "./PhoneOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports